// js/custom-element/section/image-with-text-overlay/image-with-text-overlay-list.js
if (!customElements.get('image-with-text-overlay-item')) {
    var ImageWithTextOverlayItem = class extends CustomHTMLElement {
      connectedCallback() {
        if (this.hasAttribute('parallax') && !MediaFeatures.prefersReducedMotion()) {
          this._hasPendingRaF = false;
          this._onScrollListener = this._onScroll.bind(this);
          window.addEventListener('scroll', this._onScrollListener);
        }
        if (this.hasAttribute('reveal-on-scroll')) {
          this._setupVisibility();
        }
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        if (this._onScrollListener) {
          window.removeEventListener('scroll', this._onScrollListener);
        }
      }
      async _setupVisibility() {
        await this.untilVisible();
        const images = await resolveAsyncIterator(this.querySelectorAll('.image-overlay__image')),
          headings = await resolveAsyncIterator(this.querySelectorAll('split-lines')),
          prefersReducedMotion = MediaFeatures.prefersReducedMotion();
  
        for (const image of images) {
          await imageLoaded(image);
        }
  
        const innerEffect = [
          ...images.map((image) => {
            return new CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, 'scale(1)'] }, { duration: 500, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' });
          }),
          new ParallelEffect(
            headings.map((item, index) => {
              return new CustomKeyframeEffect(
                item,
                {
                  opacity: [0, 0.2, 1],
                  transform: [`translateY(${prefersReducedMotion ? 0 : '100%'})`, 'translateY(0)'],
                  clipPath: [`inset(${prefersReducedMotion ? '0 0 0 0' : '0 0 100% 0'})`, 'inset(0 0 0 0)'],
                },
                {
                  duration: 300,
                  delay: prefersReducedMotion ? 0 : 120 * index,
                  easing: 'cubic-bezier(0.5, 0.06, 0.01, 0.99)',
                }
              );
            })
          ),
          new CustomKeyframeEffect(this.querySelector('.image-overlay-list__item-button'), { opacity: [0, 1] }, { duration: 300 }),
        ];
        const animation = prefersReducedMotion ? new CustomAnimation(new ParallelEffect(innerEffect)) : new CustomAnimation(new SequenceEffect(innerEffect));
        this._hasSectionReloaded ? animation.finish() : animation.play();
      }
      _onScroll() {
        if (this._hasPendingRaF) {
          return;
        }
        this._hasPendingRaF = true;
        requestAnimationFrame(() => {
          const boundingRect = this.getBoundingClientRect(),
            speedFactor = 3,
            contentElement = this.querySelector('.image-overlay-list__item-content'),
            imageElement = this.querySelector('.image-overlay__image'),
            boundingRectBottom = boundingRect.bottom,
            boundingRectHeight = boundingRect.height,
            stickyHeaderOffset = getStickyHeaderOffset();
          if (contentElement) {
            contentElement.style.opacity = Math.max(1 - speedFactor * (1 - Math.min(boundingRectBottom / boundingRectHeight, 1)), 0).toString();
          }
          if (imageElement) {
            imageElement.style.transform = `translateY(${100 - Math.max(1 - (1 - Math.min(boundingRectBottom / (boundingRectHeight + stickyHeaderOffset), 1)), 0) * 100}px)`;
          }
          this._hasPendingRaF = false;
        });
      }
    };
    window.customElements.define('image-with-text-overlay-item', ImageWithTextOverlayItem);
  }
  